








































































































import { Component, Vue } from "vue-property-decorator";
import { PlayerMonitor } from "@/services/players/types";
import { getAllPlayerMonitors, deletePlayerMonitor } from "@/services/players/playerMonitorService";
import { playerMonitorsFields } from "@/components/players/fields/playerMonitorsFields";
import PlayerMonitorDeleteModal from "@/components/players/modals/PlayerMonitorDeleteModal.vue";

@Component({
    components: { PlayerMonitorDeleteModal }
})
export default class PlayerMonitors extends Vue {
    // Local state
    playerMonitors = [] as Array<PlayerMonitor>;
    isBusy = false;
    fields = playerMonitorsFields;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks

    public created() {
        this.fetchData();
    }

    // computed
    get filteredData() {
        return this.playerMonitors && this.playerMonitors
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                    x.description.toLowerCase().includes(this.searchQuery.toLowerCase()));
    }

    // methods
    get createPlayerMonitor() {
        return {
            name: "createPlayerMonitor"
        };
    }

    deletePlayerMonitor(id: string, name: string) {
        (this.$refs.deleteModal as any).open(id, name);
    }

    onDeleted(id: string) {
        deletePlayerMonitor(id).then(() => this.fetchData());
    }

    fetchData() {
        this.isBusy = true;
        getAllPlayerMonitors().then((response: Array<PlayerMonitor>) => {
            this.playerMonitors = response;
            this.isBusy = false;
        });
    }
}
